import { useLayoutEffect } from 'react'

/**
 * Freezes page scrolling while `locked` is true, compensating for the width of
 * the scrollbar so the page behind the modal doesn't jump sideways.
 */
export function useLockBodyScroll(locked: boolean): void {
  useLayoutEffect(() => {
    if (!locked) return

    const { body, documentElement } = document
    const gutter = window.innerWidth - documentElement.clientWidth
    const previousGutter = body.style.getPropertyValue('--scrollbar-gutter')

    body.style.setProperty('--scrollbar-gutter', `${gutter}px`)
    body.dataset.scrollLocked = 'true'

    return () => {
      delete body.dataset.scrollLocked
      if (previousGutter) body.style.setProperty('--scrollbar-gutter', previousGutter)
      else body.style.removeProperty('--scrollbar-gutter')
    }
  }, [locked])
}
